import styles from '../../@patternfly/patternfly-next/layouts/Grid/grid.css.js';
import { getModifier } from '@patternfly/react-styles';

export var gridSpans = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export var getRowSpanKey = function getRowSpanKey(size) {
  return size + 'RowSpan';
};

export var getOffsetKey = function getOffsetKey(size) {
  return size + 'Offset';
};

export var getSizeSuffix = function getSizeSuffix(size) {
  return size ? '-on-' + size : '';
};

export var getSpanModifier = function getSpanModifier(value, size) {
  return getModifier(styles, value + '-col' + getSizeSuffix(size));
};

export var getGridSpanModifier = function getGridSpanModifier(value, size) {
  return getModifier(styles, '-all-' + value + '-col' + getSizeSuffix(size));
};

export var getRowSpanModifier = function getRowSpanModifier(value, size) {
  return getModifier(styles, value + '-row' + getSizeSuffix(size));
};

export var getOffsetModifier = function getOffsetModifier(value, size) {
  return getModifier(styles, 'offset-' + value + '-col' + getSizeSuffix(size));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/layouts/Grid/gridUtils.js
// module id = 124
// module chunks = 0